import AwesomeDebouncePromise from 'awesome-debounce-promise';
import ApiService from '../services/apiService';

export const indexLanguagesRequest = ({ dispatch, params = {}, failureCallback, successCallback }) =>
  ApiService.request('get', '/languages', {
    dispatch,
    params,
    failureCallback,
    successCallback
  });

export const debounceIndexLanguagesRequest = AwesomeDebouncePromise(indexLanguagesRequest, 300);
